<p class="field-label">{{ label() }}</p>
<orbit-input
  [autocomplete]="autocomplete()"
  [inputType]="inputType()"
  [name]="name()"
  [testId]="testId()"
  [disabled]="disabled()"
  [placeholder]="placeholder()"
  [controller]="controller()" />
